import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Row } from "reactstrap";
import Chart from "react-google-charts";
import axios from "axios";
import DataTable from "../Components/DataTable";
import { saveAs } from "file-saver";
import { Autocomplete, TextField } from "@mui/material";
import { withNamespaces } from "react-i18next";
import { withStyles } from "@material-ui/core";
import FormFiltros from "./model/form";
import { Dropdown } from "semantic-ui-react";
import { DatePicker } from "antd";
import { ResponsivePie } from "@nivo/pie";
import moment from "moment";
import Loader from "./../../Global/Loader";
import { Services } from "../../../repositories/clients/Services";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { withRouter } from "react-router-dom";
import { ShowForRole } from "../../Global/Permission";
import { moduleActions } from "../../Global/Permission/constants";


const IMGpdf =
  "https://magiclog.blob.core.windows.net/europartnerspic/pdficon.png";
const IMGFolder =
  "https://magiclog.blob.core.windows.net/europartnerspic/carpeta-icon.png";

const { RangePicker } = DatePicker;

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000a2e",
  },
  euroDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});

class Finanzas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _rolId: props._rolId,
      headers: [
        this.props.t("invoice_num"),
        this.props.t("company"),
        this.props.t("product"),
        this.props.t("invoice_date"),
        this.props.t("due_date"),
        this.props.t("type"),
        this.props.t("shipment_num"),
        this.props.t("comercial_invoice"),
        this.props.t("brands_number"),
        this.props.t("currency"),
        this.props.t("total_amount"),
        this.props.t("received_amount"),
        this.props.t("due_amount"),
        this.props.t("status"),
      ],
      keys: [
        "Number",
        "CustomerName",
        "Product",
        "InvoiceDate",
        "DueDate",
        "Type",
        "ShipmentNumber",
        "CommercialInvoice",
        "Marks",
        "Currency",
        "TotalAmount",
        "AmountReceived",
        "CollectionOutstandingBalance",
        "Status",
      ],
      lng: props.lng,
      isMovil: false,
      loading: true,
      showMontoFacturacion: false,
      showMontoTopProducto: false,
      advancedSearch2: FormFiltros,
      showMontoEstatusFactura: true,
      sumaryInfo: "",
      maxFacturacion: 0,
      maxFacturacionDias: 0,
      colorEstatus: "#000a2e",
      colors: ["#000a2e", "#0561fc", "#a6258f", "#fe5229"],
      facturacionData: {},
      fechaCorte: "",
      creditoData: {},
      montoTotal: "",
      activeInvoicePage: 1,
      totalInvoicePages: 0,
      generalGraphData: {},
      facturacionTopData: {},
      numberPageInvoice: 1,
      searchInvoice: "",
      limitInvoice: 10,
      dataInvoice: [],
      excelInvoiceLoading: false,
      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : "[0]",
      columnsTable: [
        {
          label: "",
          key: "",
          CollapseTable: true,
          flatColor: true,
          keydatavalidate: "Status",
          minWidth: 50,
          maxWidth: 50,
        },
        {
          label: this.props.t("invoice_num"),
          key: "Number",
          minWidth: 240,
          maxWidth: 240,
          showAllText: true,
        },
        {
          label: this.props.t("company"),
          minWidth: 220,
          maxWidth: 220,
          limitString: 40,
          key: "CustomerName",
        },
        { label: this.props.t("product"), key: "Product" },
        { label: this.props.t("invoice_date"), key: "InvoiceDate" },
        { label: this.props.t("due_date"), key: "DueDate" },
        { label: this.props.t("type"), key: "Type" },
        {
          label: this.props.t("shipment_num"),
          key: "ShipmentNumber",
          minWidth: 240,
          maxWidth: 240,
          custom: (value) => {
            if (value.ShipmentNumber && value.ShipmentNumber != "") {
              if (value.ShipmentId && value.ShipmentId > 0) {
                return (
                  <span
                    className="link-euro"
                    onClick={() => {
                      this.toggleShipment(value.ShipmentId);
                    }}
                  >
                    {value.ShipmentNumber}
                  </span>
                );
              } else {
                return value.ShipmentNumber;
              }
            } else {
              return false;
            }
          },
        },
        {
          label: this.props.t("comercial_invoice"),
          key: "CommercialInvoice",
          minWidth: 200,
          maxWidth: 200,
          limitString: 40,
        },
        {
          label: this.props.t("brands_number"),
          key: "Marks",
          minWidth: 200,
          maxWidth: 200,
          limitString: 40,
        },
        { label: this.props.t("currency"), key: "Currency" },
        {
          label: this.props.t("total_amount"),
          minWidth: 100,
          maxWidth: 100,
          key: "TotalAmount",
          custom: (value) => (
            <span>
              {this.currencyFormatter2({
                currency: "USD",
                value: value.TotalAmount
                  ? value.TotalAmount
                  : 0,
              })}
            </span>
          ),
        },
        {
          label: this.props.t("received_amount"),
          minWidth: 100,
          maxWidth: 100,
          key: "AmountReceived",
          custom: (value) => (
            <span>
              {this.currencyFormatter2({
                currency: "USD",
                value: value.AmountReceived
                  ? value.AmountReceived
                  : 0,
              })}
            </span>
          )
        },
        {
          label: this.props.t("due_amount"),
          minWidth: 100,
          maxWidth: 100,
          key: "TotalAmount",
          custom: (value) => (
            <span>
              {this.currencyFormatter2({
                currency: "USD",
                value: value.CollectionOutStandingBalance
                  ? value.CollectionOutStandingBalance
                  : 0,
              })}
            </span>
          ),
        },
        { label: this.props.t("status"), key: "Status" },
        {
          label: "",
          key: "",
          minWidth: 100,
          maxWidth: 100,
          custom: (value) => {
            if (
              value.URLDocument &&
              value.URLDocument != "" &&
              value.URLDocument.includes("http")
            ) {
              return (
                <img
                  title={this.props.t("invoice")}
                  src={IMGpdf}
                  style={{ width: "30px", height: "30px", cursor: "pointer" }}
                  onClick={() => {
                    this.showPdf(value.URLDocument);
                  }}
                ></img>
              );
            } else {
              return false;
            }
          },
        },
        {
          label: "",
          key: "",
          minWidth: 100,
          maxWidth: 100,
          custom: (value) => {
            if (
              value.URLPublicFiles &&
              value.URLPublicFiles != "" &&
              value.URLPublicFiles.includes("http")
            ) {
              return (
                <img
                  title={this.props.t("additional_support")}
                  src={IMGFolder}
                  style={{ width: "30px", height: "30px", cursor: "pointer" }}
                  onClick={() => {
                    this.showPdf(value.URLPublicFiles);
                  }}
                ></img>
              );
            } else {
              return false;
            }
          },
        },
      ],
      subTable: [
        {
          label: this.props.t("line"),
          minWidth: 50,
          maxWidth: 50,
          width: 50,
          key: "LineNo",
        },
        {
          label: this.props.t("concept"),
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          key: "Concept",
        },
        {
          label: this.props.t("amount"),
          width: 100,
          minWidth: 100,
          maxWidth: 100,
          key: "Amount",
          custom: (value) => (
            <span>{this.currencyFormat(parseFloat(value.Amount))}</span>
          ),
        },
      ],
    };
  }
  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    this.setState({
      isMovil: isMobileDevice,
    });

    this.getGraphs();
    this.getInvoiceInfo();
    this.getInvoiceTotals();
    this.getCatalogs();
  };
  convertImgToBase64 = (url, callback, outputFormat) => {
    var canvas = document.createElement("CANVAS");
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function () {
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      var dataURL = canvas.toDataURL(outputFormat || "image/png");
      callback.call(this, dataURL);
      canvas = null;
    };
    img.src = url;
  };
  toggleShipment = (shipmentId) => {
    this.props.history.push(`/shipments-details/${shipmentId}`);
  };
  showPdf = (url) => {
    let pdfWindow = window.open("");
    pdfWindow.location.href = url;
  };
  getCatalogs = () => {
    let { catalogCombo, lng } = this.state;
    let data = {
      client: this.state.clientesSelect,
      lang: lng,
    };
    axios
      .post(`${Services.FINANZAS.path}finanzas/filterCatalog`, data)
      .then((success) => {
        catalogCombo = success.data.data;
        this.setState(
          {
            catalogCombo,
          },
          () => {
            this.generateFilters();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };
  generateFilters = (newCat) => {
    const { advancedSearch2, catalogCombo, Form } = this.state;
    let Inputs = advancedSearch2.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[
                this.props.t("start_date"),
                this.props.t("end_date"),
              ]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                      moment(new Date(e.values[0].init)),
                      moment(new Date(e.values[0].end)),
                    ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
              }}
              id={e.id}
              onChange={this.handleChangeDatePicKer(e.id)}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {this.props.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                this.handleChangeSelectMultiple(e.id, value)
              }
              noResultsMessage={this.props.t("no_results_found")}
              id={e.id}
              options={catalogCombo[e.options]}
              clearable
              search
              selection
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
    });
    let NewInput = (
      <div className="row">
        <div className="col-12">
          <span className="icon-clear icons-front-module float-right"
            title={this.props.t("remove_filters")}
            onClick={this.resetAdvance}
          />
        </div>
        {Inputs}
      </div>
    );
    this.setState({
      filtros: NewInput,
    });
  };
  resetAdvance = () => {
    let { advancedSearch2 } = this.state;
    advancedSearch2.map((advData) => {
      advData.values = [];
    });
    this.setState({ advancedSearch2 }, () => {
      this.findAdvanced();
      this.generateFilters();
    });
  };

  handleChangeSelectMultiple = (id, value) => {
    let { advancedSearch2, catalogCombo } = this.state;
    for (let i = 0; i < advancedSearch2.length; i++) {
      const e = advancedSearch2[i];
      if (e.id == id) {
        e.values = value;
      }
    }

    this.setState({ advancedSearch2 }, () => {
      this.generateFilters();
      this.findAdvanced();
    });
  };

  handleChangeDatePicKer = (name) => (event) => {
    let { advancedSearch2 } = this.state;

    try {
      if (event) {
        advancedSearch2.map((search) => {
          if (search.id == name) {
            search.values = [
              {
                init: event[0].format("YYYY-MM-DD HH:mm:ss"),
                end: event[1].format("YYYY-MM-DD HH:mm:ss"),
              },
            ];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.findAdvanced();
        });
      } else {
        advancedSearch2.map((search) => {
          if (search.id == name) {
            search.values = [];
          }
        });
        this.setState({ advancedSearch2 }, () => {
          this.generateFilters();
          this.findAdvanced();
        });
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  findAdvanced = () => {
    let obj = [];
    this.state.advancedSearch2.map((e) => {
      if (e.values && e.values.length > 0) {
        let newPush = {
          id: e.id2,
          UseIN: true,
          isDate: e.type === "Datetime" ? true : false,
          value: e.values,
        };
        obj.push(newPush);
      } else {
        obj.push({
          id: e.id,
          UseIN: false,
          value: e.value,
        });
      }
    });
    this.setState(
      { advancedObj: obj, numberPageInvoice: 1, activeInvoicePage: 1 },
      () => {
        this.getInvoiceInfo();
      }
    );
  };

  getGraphs = async () => {
    let data = {
      userId: this.props._user,
      customers: this.props.clients,
      lang: this.props.lng,
    };
    axios
      .post(`${Services.FINANZAS.path}finanzas/getGraphs`, { data })
      .then((res) => {
        this.setState(
          {
            generalGraphData: res.data,
            colorEstatus: "#000a2e",
          },
          () => {
            this.generateFacturacionData("monto");
            this.generateLineaCreditoData();
            this.generateEstatusData("monto");
            this.generateTop("monto");
          }
        );
      })
      .catch((ex) => {
        console.error("Error al obtener graficas", ex);
      });
  };

  colores = (startHex) => {
    var start = this.convertToRGB(startHex);
    var end = this.convertToRGB("#FFFFFF");

    var alpha = 0.7;
    var c = [];

    c[0] = start[0] * alpha + (1 - alpha) * end[0];
    c[1] = start[1] * alpha + (1 - alpha) * end[1];
    c[2] = start[2] * alpha + (1 - alpha) * end[2];
    return "#" + this.convertToHex(c);
  };
  hex = (c) => {
    var s = "0123456789abcdef";
    var i = parseInt(c);
    if (i == 0 || isNaN(c)) return "00";
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
  };
  convertToHex = (rgb) => {
    return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
  };
  trim = (s) => {
    return s.charAt(0) == "#" ? s.substring(1, 7) : s;
  };
  generateTop = (tipo) => {
    let { generalGraphData, maxFacturacionDias } = this.state;
    var estatus = [];
    maxFacturacionDias = 0;
    var colorInicial = "#000a2e";
    let infoGraph =
      tipo == "monto"
        ? generalGraphData.facturacionTop.monto
        : generalGraphData.facturacionTop.total;
    infoGraph.sort((a, b) => {
      return parseFloat(b[1] - parseFloat(a[1]));
    });

    infoGraph.map((value) => {
      estatus.push({
        nombre: value[0] == "" ? this.props.t("no_status") : value[0],
        total: parseFloat(value[1]),
        color: colorInicial,
        extra: "",
      });
      maxFacturacionDias =
        maxFacturacionDias > parseFloat(value[1])
          ? maxFacturacionDias
          : parseFloat(value[1]);
      colorInicial = this.colores(colorInicial);
    });

    let Logistics = [
      [
        "Element",
        "Total",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
        { type: "string", role: "tooltip", p: { html: true } },
      ],
    ];
    try {
      estatus.map((value) => {
        const element = value;
        Logistics.push([
          element.nombre,
          element.total,
          element.color,
          element.extra,
          tipo == "monto"
            ? "<div style='margin-top:10px;margin-bottom:10px;text-align: center; width:100%;' > <label>" +
            this.props.t("amount") +
            ":</label> <b>" +
            this.currencyFormat(parseFloat(element.total)) +
            "</b></div>"
            : "<div style='margin-top:10px;margin-bottom:10px;text-align: center; width:100%;' >  <label>" +
            this.props.t("invoices") +
            ": </label> <b>" +
            this.numberFormat(parseFloat(element.total)) +
            "</b></div>",
        ]);
      });
    } catch (error) {
      console.error("error", error);
    } finally {
      this.setState({
        maxFacturacionDias,
        facturacionTopData: Logistics,
        showMontoTopProducto: tipo == "monto",
      });
    }
  };
  convertToRGB = (hex) => {
    var color = [];
    color[0] = parseInt(this.trim(hex).substring(0, 2), 16);
    color[1] = parseInt(this.trim(hex).substring(2, 4), 16);
    color[2] = parseInt(this.trim(hex).substring(4, 6), 16);
    return color;
  };

  generateEstatusData = (tipo) => {
    let { estatusFacturasData, generalGraphData, showMontoEstatusFactura, colors } =
      this.state;
    estatusFacturasData = [];

    let arrayGraph =
      tipo == "monto"
        ? generalGraphData.estatusFacturas.monto
        : generalGraphData.estatusFacturas.cantidad;
    arrayGraph.map((est, i) => {
      estatusFacturasData.push({
        id: est[0] == "" ? this.props.t("no_status") : est[0],
        label: est[0] == "" ? this.props.t("no_status") : est[0],
        value: est[1] ? parseInt(est[1]) : 0,
        color: colors[i],
      });
    });
    this.setState({
      estatusFacturasData,
      showMontoEstatusFactura: tipo == "monto",
    });
  };
  getColorEstatus = () => {
    let color = "";
    color = this.colores(this.state.colorEstatus);
    return color;
  };
  generateLineaCreditoData = () => {
    let { creditoData, generalGraphData, montoTotal, colors } = this.state;
    creditoData = [];

    generalGraphData.limiteCredito.limite.map((cred, i) => {
      if (cred[0] == "Monto total" || cred[0] == "Total amount") {
        montoTotal = cred[1]
          ? this.currencyFormat(parseFloat(cred[1]))
          : this.currencyFormat(0);
      } else {
        creditoData.push({
          id: cred[0],
          label: cred[0],
          value: cred[1] ? parseFloat(cred[1]) : 0,
          color:
            cred[0].toLowerCase() == "monto disponible" || "amount aviable"
              ? "#0561fc"
              : "#dedc00",
        });
      }
    })
    this.setState({ creditoData, montoTotal });
  };

  currencyFormatter2({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    });
    return formatter.format(value);
  }

  currencyFormat = (num) => {
    return (
      "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    ).replace(".00", "");
  };
  numberFormat = (num) => {
    return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  generateFacturacionData = (tipo) => {
    let { facturacionData, maxFacturacion, generalGraphData } = this.state;
    maxFacturacion = 0;
    facturacionData = [
      [
        "x",
        "Facturación",
        { type: "string", role: "tooltip", p: { html: true } },
      ],
    ];
    let arrayGraph =
      tipo == "monto"
        ? generalGraphData.facturacion.monto
        : generalGraphData.facturacion.total;
    arrayGraph.map((fact) => {
      facturacionData.push([
        fact[0],
        fact[1] ? parseFloat(fact[1]) : 0,
        tipo == "monto"
          ? "<div style='margin-top:10px;margin-bottom:10px;text-align: center; width:100%;' > <label>" +
          this.props.t("amount") +
          ": </label> <b>" +
          this.currencyFormat(parseFloat(fact[1])) +
          "</b></div>"
          : "<div style='margin-top:10px;margin-bottom:10px;text-align: center; width:100%;' >  <label> " +
          this.props.t("invoices") +
          ": </label> <b>" +
          this.numberFormat(parseFloat(fact[1])) +
          "</b></div>",
      ]);
      if ((fact[1] ? parseFloat(fact[1]) : 0) > maxFacturacion) {
        maxFacturacion = parseFloat(fact[1]);
      }
    });
    this.setState({
      maxFacturacion,
      facturacionData,
      showMontoFacturacion: tipo == "monto",
    });
  };

  getInvoiceTotals = () => {
    let data = {
      client: this.state.clientesSelect,
    };

    axios
      .post(`${Services.FINANZAS.path}finanzas/getInvoiceTotals`, data)
      .then((success) => {
        let { sumaryInfo } = this.state;

        let amount = this.currencyFormat(
          parseFloat(success.data.totalAmount ? success.data.totalAmount : 0)
        );
        let totalInvoices = this.numberFormat(
          parseFloat(
            success.data.totalInvoices ? success.data.totalInvoices : 0
          )
        );
        sumaryInfo = (
          <>
            <Row>
              <div className="col-xs-12 col-md-6 col-lg-6">
                <p>
                  <span className="titleCard">
                    {this.props.t("total_amount_docs")}
                  </span>
                </p>
                <span className="label-euro">{amount}</span>
              </div>
              <div className="col-xs-12 col-md-6 col-lg-6">
                <p>
                  <span className="titleCard">
                    {this.props.t("total_docs")}
                  </span>
                </p>
                <span className="label-euro">{totalInvoices}</span>
              </div>
            </Row>
          </>
        );

        this.setState({
          sumaryInfo,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getInvoiceInfo = () => {
    let {
      lng,
      clientesSelect,
      numberPageInvoice,
      limitInvoice,
      searchInvoice,
      advancedObj,
    } = this.state;
    let data = {
      client: clientesSelect,
      pag: numberPageInvoice,
      limit: limitInvoice,
      EsDTA: 0,
      search: searchInvoice,
      advanced: advancedObj,
      lang: lng,
    };

    axios
      .post(`${Services.FINANZAS.path}finanzas/getInvoice`, data)
      .then((success) => {
        let data = success.data.data;
        this.setState({
          dataInvoice: data,
          totalInvoicePages: success.data.totalPage,
          fechaCorte: success.data.MaxUpdateDate,
          loading: false,
        });
      })
      .catch((error) => {
        console.warn(error);
      });
  };
  /**
   * Data table section
   */
  setInvoiceSearch = (value) => {
    if (this.state.search === value) return;

    this.setState(
      {
        searchInvoice: value,
        activeInvoicePage: 1,
        numberPageInvoice: 1,
        loading: true,
      },
      () => {
        this.getInvoiceInfo();
      }
    );
  };
  generateInvoiceExcel = () => {
    let { lng } = this.state;
    this.setState({
      excelInvoiceLoading: true,
    });

    let data = {
      client: this.state.clientesSelect,
      pag: this.state.numberPageInvoice,
      limit: this.state.limitInvoice,
      EsDTA: 0,
      search: this.state.searchInvoice,
      advanced: this.state.advancedObj,
      lang: lng,
      query: {
        allData: true,
      },
    };

    axios
      .post(`${Services.FINANZAS.path}finanzas/getInvoice`, data)
      .then((success) => {
        let data = success.data.data;
        /**
         * Se convierte a flotante para que en el excel se tome en cuenta como numero
         */
        if (data && data.length > 0) {
          data.map((d) => {
            d.TotalAmount = parseFloat(d.TotalAmount);
          });
        }
        let dateNow = new Date();
        let titleDownload = `${this.props.t("invoice_list")}-${dateNow.getFullYear() +
          (dateNow.getMonth() + 1).toString().padStart(2, "0") +
          dateNow.getDate().toString().padStart(2, "0")
          }`;
        let info = {
          config: {},
        };

        let options = {
          headers: this.state.headers,
          keys: this.state.keys,
          image: {
            name: "euro",
          },
          sheetName: this.props.t("invoices"),
          font: 'SF Pro Display',
        };
        axios
          .post(`${Services.REPORT.path}report/dynamic/xlsx`, {
            info,
            data,
            options,
          })
          .then((success) => {
            if (success.data.base64) {
              const fileName = titleDownload + ".xlsx";
              const linkSource = `data:application/xlsx;base64,${success.data.base64}`;
              saveAs(linkSource, fileName);
              this.setState({
                excelInvoiceLoading: false,
              });
            } else console.warn("Error downloading file", success);
          });
      })
      .catch((error) => {
        console.warn(error);
      });
  };
  changePage = (e, { activePageOrder }) => {
    this.setState(
      {
        numberPageInvoice: activePageOrder,
        activeInvoicePage: activePageOrder,
        loading: true
      },
      () => {
        this.getInvoiceInfo();
      }
    );
  };

  handleChangeDrop = (attribute) => (evt, data) => {
    let campo = data ? data.value : null;
    if (attribute == "facturacionusd") {
      this.generateFacturacionData(campo);
    } else if (attribute == "facturaciontop") {
      this.generateTop(campo);
    } else if (attribute == "estatusfactura") {
      this.generateEstatusData(campo);
    }
  };

  render() {
    let {
      loading,
      facturacionData,
      maxFacturacion,
      maxFacturacionDias,
      creditoData,
      estatusFacturasData,
      facturacionTopData,
      showMontoEstatusFactura,
      fechaCorte,
      colors,
      showMontoTopProducto,
      isMovil,
      _rolId,
    } = this.state;
    const { classes } = this.props;
    return (
      <ContentWrapper>
        <Loader hidden={!loading} />
        <div className="content-heading">
          <span className="icon-finance icon-header" />
          {this.props.t("finance")}
          <div className="euro-return-tittle">
            <span className="label-date">
              {this.props.t("cutoff_date")}:
            </span>
            <span className="value-date">
              {fechaCorte}
            </span>
          </div>
        </div>
        <Row>

          <div className="col-xs-12 col-md-6 .col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title row">
                  <div className="col-xs-12 col-md-8 col-lg-8">
                    {this.props.t("invoicing_status")}
                  </div>
                  <div className="col-xs-12 col-md-4 col-lg-4">
                    <Autocomplete
                      closeText={false}
                      openText={false}
                      disableClearable={true}
                      style={{ marginTop: "6px" }}
                      id="size-small-standard"
                      className="input-euro"
                      size="small"
                      ListboxProps={{
                        sx: { fontSize: 12 },
                      }}
                      sx={{
                        "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                          fontSize: 12,
                        },
                      }}
                      options={[
                        {
                          label: this.props.t("amount"),
                          text: "Monto",
                          value: "monto",
                        },
                        {
                          label: this.props.t("quantity"),
                          text: "Cantidad",
                          value: "total",
                        },
                      ]}
                      defaultValue={{
                        label: this.props.t("amount"),
                        text: "Monto",
                        value: "monto",
                      }}
                      onChange={this.handleChangeDrop("estatusfactura")}
                      renderInput={(params) => {
                        return (
                          <TextField
                            {...params}
                            variant="standard"
                            className={classes.textfield}
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="card-body"
                style={{ overflow: "hidden", height: "100%" }}
              >
                <div id="" style={{ height: "100%" }}>
                  {estatusFacturasData && estatusFacturasData.length > 0 ? (
                    showMontoEstatusFactura ? (
                      <>
                        {isMovil ? (
                          <div className="d-flex justify-content-center align-items-center">
                            {estatusFacturasData.map((e) => {
                              return (
                                <>
                                  <i
                                    className="fas fa-circle m-1"
                                    style={{ color: e.color }}
                                  ></i>
                                  <span className="label-graphic">
                                    {e.label}
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <ResponsivePie
                          data={estatusFacturasData}
                          // margin={{ top: 20, right: 20, bottom: 50, left: -20 }}
                          margin={{ top: 20, right: 20, bottom: 50, left: 20 }}
                          pixelRatio={1}
                          startAngle={-18}
                          innerRadius={0.5}
                          cornerRadius={0}
                          padAngle={0.7}
                          // colors={this.state.estatusFacturasData.map((est) => {
                          //   return est.color;
                          // })}
                          colors={colors}
                          borderColor={{
                            from: "color",
                            modifiers: [["darker", "0"]],
                          }}
                          legends={
                            isMovil
                              ? []
                              : [
                                {
                                  anchor: !isMovil ? "center" : "bottom",
                                  direction: !isMovil ? "column" : "row",
                                  justify: false,
                                  translateX: isMovil ? 0 : 185,
                                  translateY: isMovil ? 40 : 0,
                                  itemsSpacing: 10,
                                  itemWidth: isMovil ? 90 : 100,
                                  itemHeight: 18,
                                  itemTextColor: "#999",
                                  itemDirection: "left-to-right",
                                  itemOpacity: 1,
                                  symbolSize: 18,
                                  symbolShape: "circle",
                                  effects: [
                                    {
                                      on: "hover",
                                      style: {
                                        itemTextColor: "#000",
                                      },
                                    },
                                  ],
                                },
                              ]
                          }
                          tooltip={(val) => {
                            return (
                              <div
                                className="row"
                                style={{
                                  border: "1px #000a2e solid",
                                  backgroundColor: "#fdfbfb",
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div className="col-12 col-md-12 col-lg-12">
                                  <h5>
                                    {" "}
                                    {val.datum.id} : $
                                    {Number(val.datum.value).toLocaleString(
                                      "En-us"
                                    )}{" "}
                                  </h5>
                                </div>
                              </div>
                            );
                          }}
                          slicesLabelsSkipAngle={20}
                          arcLabelsTextColor="#fdfbfb"
                          arcLabelsSkipAngle={20}
                          enableArcLinkLabels={false}
                          arcLabel={function (e) {
                            return (
                              "$" + Number(e.value).toLocaleString("En-us")
                            );
                          }}
                        />
                      </>
                    ) : (
                      <>
                        {isMovil ? (
                          <div className="d-flex justify-content-center align-items-center">
                            {estatusFacturasData.map((e) => {
                              return (
                                <>
                                  <i
                                    className="fas fa-circle m-1"
                                    style={{ color: e.color }}
                                  ></i>
                                  <span className="label-graphic">
                                    {e.label}
                                  </span>
                                </>
                              );
                            })}
                          </div>
                        ) : (
                          <div></div>
                        )}
                        <ResponsivePie
                          data={estatusFacturasData}
                          margin={{ top: 20, right: 20, bottom: 50, left: -20 }}
                          pixelRatio={1}
                          startAngle={-18}
                          innerRadius={0.5}
                          cornerRadius={0}
                          padAngle={0.7}
                          colors={this.state.estatusFacturasData.map((est) => {
                            return est.color;
                          })}
                          borderColor={{
                            from: "color",
                            modifiers: [["darker", "0"]],
                          }}
                          legends={
                            isMovil
                              ? []
                              : [
                                {
                                  anchor: "center",
                                  direction: "column",
                                  justify: false,
                                  translateX: 185,
                                  itemsSpacing: 10,
                                  itemWidth: 100,
                                  itemHeight: 18,
                                  itemTextColor: "#999",
                                  itemDirection: "left-to-right",
                                  itemOpacity: 1,
                                  symbolSize: 18,
                                  symbolShape: "circle",
                                  effects: [
                                    {
                                      on: "hover",
                                      style: {
                                        itemTextColor: "#000",
                                      },
                                    },
                                  ],
                                },
                              ]
                          }
                          tooltip={(val) => {
                            return (
                              <div
                                className="row"
                                style={{
                                  border: "1px #000a2e solid",
                                  backgroundColor: "#fdfbfb",
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div className="col-12 col-md-12 col-lg-12">
                                  <h5>
                                    {" "}
                                    {val.datum.id} :{" "}
                                    {this.numberFormat(val.datum.value)}{" "}
                                  </h5>
                                </div>
                              </div>
                            );
                          }}
                          slicesLabelsSkipAngle={20}
                          arcLabelsTextColor="#fdfbfb"
                          arcLabelsSkipAngle={20}
                          enableArcLinkLabels={false}
                          arcLabel={(e) => {
                            return this.numberFormat(e.value);
                          }}
                        />
                      </>
                    )
                  ) : (
                    false
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 .col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title row">
                  <div className="col-xs-12 col-md-8 col-lg-8">
                    {this.props.t("invoicing_usd")}
                  </div>
                  <div className="col-xs-12 col-md-4 col-lg-4">
                    <Autocomplete
                      closeText={false}
                      openText={false}
                      disableClearable={true}
                      style={{ marginTop: "6px" }}
                      id="size-small-standard"
                      className="input-euro"
                      size="small"
                      ListboxProps={{
                        sx: { fontSize: 12 },
                      }}
                      sx={{
                        "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                          fontSize: 12,
                        },
                      }}
                      options={[
                        {
                          label: this.props.t("amount"),
                          text: "Monto",
                          value: "monto",
                        },
                        {
                          label: this.props.t("quantity"),
                          text: "Cantidad",
                          value: "total",
                        },
                      ]}
                      defaultValue={{
                        label: this.props.t("amount"),
                        text: "Monto",
                        value: "monto",
                      }}
                      onChange={this.handleChangeDrop("facturacionusd")}
                      renderInput={(params) => {
                        return (
                          <TextField
                            {...params}
                            variant="standard"
                            className={classes.textfield}
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="card-body"
                style={{ padding: "0px !important", overflow: "hidden" }}
              >
                <div id="chartDashboard">
                  {
                    // maxFacturacion > 0 ? (
                    this.state.showMontoFacturacion ? (
                      <Chart
                        style={{
                          height: "300px",
                          marginTop: "-15px",
                        }}
                        className={"valueTable"}
                        chartType="LineChart"
                        loader={<div>Loading Chart</div>}
                        data={facturacionData}
                        options={{
                          chartArea: {
                            width: "100%",
                            left: "17%",
                          },

                          height: "100%",
                          curveType: "function",
                          legend: {
                            position: "none",
                          },
                          tooltip: {
                            isHtml: true,
                          },
                          vAxis: {
                            minValue: 0,
                            viewWindow: {
                              min: 0,
                              max: maxFacturacion + maxFacturacion * 0.2,
                            },
                            format: "$#,###",
                          },

                          pointSize: 5,
                          series: {
                            0: {
                              color: "#000a2e",

                              lineWidth: 2,
                            },
                          },
                        }}
                        rootProps={{ "data-testid": "1" }}
                      />
                    ) : (
                      <Chart
                        style={{
                          height: "300px",
                          marginTop: "-25px",
                        }}
                        className={"valueTable"}
                        chartType="LineChart"
                        loader={<div>Loading Chart</div>}
                        data={facturacionData}
                        options={{
                          chartArea: {
                            width: "100%",
                            left: "10%",
                          },
                          height: "100%",
                          curveType: "function",
                          legend: {
                            position: "none",
                          },
                          tooltip: { isHtml: true },
                          vAxis: {
                            minValue: 0,
                            viewWindow: { min: 0, max: maxFacturacion + 1 },
                          },

                          pointSize: 5,
                          series: {
                            0: {
                              color: "#000a2e",

                              lineWidth: 2,
                            },
                          },
                        }}
                        rootProps={{ "data-testid": "1" }}
                      />
                    )
                    // )
                    // : (
                    //   false
                    // )
                  }
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-6 col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title row">
                  <div className="col-xs-12 col-md-8 col-lg-8">
                    {this.props.t("invoice_per_product")}
                  </div>
                  <div className="col-xs-12 col-md-4 col-lg-4">
                    <Autocomplete
                      disableClearable={true}
                      style={{ marginTop: "6px" }}
                      id="size-small-standard"
                      className="input-euro"
                      size="small"
                      ListboxProps={{
                        sx: { fontSize: 12 },
                      }}
                      closeText={false}
                      openText={false}
                      sx={{
                        "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                          fontSize: 12,
                        },
                      }}
                      options={[
                        {
                          label: this.props.t("amount"),
                          text: "Monto",
                          value: "monto",
                        },
                        {
                          label: this.props.t("quantity"),
                          text: "Cantidad",
                          value: "total",
                        },
                      ]}
                      defaultValue={{
                        label: this.props.t("amount"),
                        text: "Monto",
                        value: "monto",
                      }}
                      onChange={this.handleChangeDrop("facturaciontop")}
                      renderInput={(params) => {
                        return (
                          <TextField
                            {...params}
                            variant="standard"
                            className={classes.textfield}
                          />
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body" style={{ overflow: "hidden" }}>
                {facturacionTopData && facturacionTopData.length > 1 ? (
                  <div id="" style={{ marginTop: "-20px" }}>
                    {showMontoTopProducto ? (
                      <Chart
                        className={"valueTable"}
                        chartType="BarChart"
                        loader={<div>Loading Chart</div>}
                        options={{
                          height: !isMovil ? "300px" : "",
                          width: "100%",
                          chartArea: {
                            width: "60%",
                            height: "80%",
                          },
                          tooltip: { isHtml: true },
                          legend: {
                            position: "none",
                          },
                          animation: {
                            startup: true,
                            easing: "linear",
                            duration: 1000,
                          },
                          hAxis: {
                            format: "$#,###",
                            minValue: 1,
                            viewWindow: {
                              min: 1,
                              max:
                                maxFacturacionDias + maxFacturacionDias * 0.5,
                            },
                          },
                        }}
                        rootProps={{ "data-testid": "6" }}
                        data={facturacionTopData}
                      />
                    ) : (
                      <Chart
                        style={{
                          height: "300px",
                          marginTop: "-15px",
                        }}
                        className={"valueTable"}
                        chartType="BarChart"
                        loader={<div>Loading Chart</div>}
                        options={{
                          width: "100%",

                          chartArea: {
                            width: "60%",
                          },
                          tooltip: { isHtml: true },
                          legend: {
                            position: "none",
                          },
                          animation: {
                            startup: true,
                            easing: "linear",
                            duration: 1000,
                          },
                          hAxis: {
                            format: "0",
                          },
                        }}
                        rootProps={{ "data-testid": "6" }}
                        data={facturacionTopData}
                      />
                    )}
                  </div>
                ) : (
                  false
                )}
              </div>
            </div>
          </div>

          <ShowForRole
            rol={_rolId}
            moduleAction={moduleActions.FINANCE_MODULE_CREDIT_LINE_GRAPHIC}>
            <div className="col-xs-12 col-md-6 col-lg-6 ">
              <div className="card myCard equalsWidth">
                <div className="card-header">
                  <div className="card-title row">
                    <div className="col-xs-12 col-md-6 col-lg-6">
                      {this.props.t("credit_line")}
                    </div>
                    <div className="col-xs-12 col-md-6 col-lg-6 d-flex justify-content-end">
                      <span className="euro-gray-label">
                        {this.props.t("credit_limit")}: {this.state.montoTotal}{" "}
                        USD
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-body" style={{ overflow: "hidden" }}>
                  {this.state.montoTotal &&
                    this.state.montoTotal != "$0.00" &&
                    creditoData &&
                    creditoData.length > 0 ? (
                    <>
                      {isMovil ? (
                        <div className="d-flex justify-content-center align-items-center">
                          {creditoData.map((e) => {
                            return (
                              <>
                                <i
                                  className="fas fa-circle m-1"
                                  style={{ color: e.color }}
                                ></i>
                                <span className="label-graphic">{e.label}</span>
                              </>
                            );
                          })}
                        </div>
                      ) : (
                        <div></div>
                      )}
                      <ResponsivePie
                        data={creditoData}
                        // margin={{ top: 20, right: 20, bottom: 50, left: -50 }}
                        margin={{ top: 20, right: 20, bottom: 50, left: 20 }}
                        pixelRatio={1}
                        startAngle={-18}
                        innerRadius={0.5}
                        cornerRadius={0}
                        padAngle={0.7}
                        colors={colors}
                        borderColor={{
                          from: "color",
                          modifiers: [["darker", "0"]],
                        }}
                        legends={
                          isMovil
                            ? []
                            : [
                              {
                                anchor: !isMovil ? "center" : "bottom",
                                direction: !isMovil ? "column" : "row",
                                justify: false,
                                translateX: isMovil ? 0 : 185,
                                translateY: isMovil ? 40 : 0,
                                itemsSpacing: 10,
                                itemWidth: isMovil ? 90 : 100,
                                // itemWidth: 100,
                                itemHeight: 18,
                                itemTextColor: "#999",
                                itemDirection: "left-to-right",
                                itemOpacity: 1,
                                symbolSize: 18,
                                symbolShape: "circle",
                                effects: [
                                  {
                                    on: "hover",
                                    style: {
                                      itemTextColor: "#000",
                                    },
                                  },
                                ],
                              },
                            ]
                        }
                        tooltip={(val) => {
                          return (
                            <div
                              className="row"
                              style={{
                                border: "1px #000a2e solid",
                                backgroundColor: "#fdfbfb",
                                height: "30px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div className="col-12 col-md-12 col-lg-12">
                                <h5>
                                  {" "}
                                  {val.datum.id} : $
                                  {Number(val.datum.value).toLocaleString(
                                    "En-us"
                                  )}{" "}
                                </h5>
                              </div>
                            </div>
                          );
                        }}
                        slicesLabelsSkipAngle={20}
                        arcLabelsTextColor="#fdfbfb"
                        arcLabelsSkipAngle={20}
                        enableArcLinkLabels={false}
                        arcLabel={function (e) {
                          return "$" + Number(e.value).toLocaleString("En-us");
                        }}
                      />
                    </>
                  ) : (
                    false
                  )}
                </div>
              </div>
            </div>
          </ShowForRole>
        </Row>

        <div className="row pt-5">
          <div className="col-lg-12 col-sm-12 col-md-12 col-12">
            <Card className="myCard" style={{ padding: "15px" }}>
              <DataTable
                labelSelected={""}
                search={this.state.searchInvoice}
                filtrosPanel={this.state.filtros}
                startSubTable={1}
                paddingSubtable="3%"
                colspanSubTable={3}
                panel={true}
                data={this.state.dataInvoice}
                columnsTable={this.state.columnsTable}
                subTable={this.state.subTable}
                excelLoading={this.state.excelInvoiceLoading}
                handleSearch={this.setInvoiceSearch}
                downloadExcel={this.generateInvoiceExcel}
                activePage={this.state.activeInvoicePage}
                pages={this.state.totalInvoicePages}
                OnPageChange={this.changePage}
                sumaryInfo={this.state.sumaryInfo}
              ></DataTable>
            </Card>
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  withStyles(useStyles)(
    connect(mapStateToProps, mapDispatchToProps)(withRouter(Finanzas))
  )
);
